<div class="py-12 px-8 text-base mx-auto">
  <p class="text-center mb-4">
    <b class="text-center">AVISO DE PRIVACIDADE DA PLATAFORMA “MOBO” </b>
    <b class="text-center block">Última atualização: 19 de novembro de 2024 </b>
  </p>

  <!-- page 1 -->
  <div>
    AO ACESSAR, USAR OU SE CADASTRAR NO SITE MOBO.COM.BR E/OU NO APLICATIVO
    “MOBO” ( <b>“Plataforma”</b> ), DISPONIBILIZADO EM LOJAS VIRTUAIS E OPERADO
    PELA MOBO CUPONS SERVIÇOS DE COMUNICAÇÃO DIGITAL LTDA., COM SEDE NA CIDADE
    DE PORTO ALEGRE, ESTADO DO RIO GRANDE DO SUL, NA AVENIDA CARLOS GOMES, N°
    2012, SALA 606, BAIRRO BOA VISTA, CEP 90480-000, INSCRITA NO CNPJ/MF SOB O
    Nº. 13.918.569/0001-82, ( <b>“Sociedade”</b> ), VOCÊ DECLARA ESTAR CIENTE E
    COMPREENDER INTEGRALMENTE OS TERMOS DO PRESENTE AVISO DE PRIVACIDADE (<b
      >“Aviso de Privacidade”</b
    >). <br />
    <br />

    <span class="text-sm"
      >Para os fins deste Aviso de Privacidade, <b>“Usuário”</b> é toda pessoa
      física que acessa a Plataforma.</span
    >
    <br />
    <br />
    Caso você esteja usando a Plataforma em nome de entidade e/ou pessoa
    jurídica, você garante estar autorizado e ter todos os poderes necessários
    para aceitar este Aviso de Privacidade em nome da respectiva entidade e/ou
    pessoa jurídica, assim como garante que a entidade e/ou pessoa jurídica que
    você representa concorda em indenizar a Sociedade por qualquer violação
    deste Aviso de Privacidade por você cometida. Caso a Plataforma seja de
    qualquer modo utilizada por menores de idade (menores de 18 anos), por
    crianças (até 12 anos de idade incompletos) e/ou colete dados de menores de
    idade ou de crianças, o tratamento dos dados destes indivíduos deverá ser
    autorizado pelos responsáveis legais do menor de idade e/ou da criança, os
    quais deverão estar cientes e de acordo com os termos deste Aviso de
    Privacidade.
    <br />
    <br />
    <b>1. DA PLATAFORMA </b> <br />
    <br />
    A Plataforma é um aplicativo gratuito que disponibiliza aos Clientes cupons
    de desconto oferecidos por Anunciantes (restaurantes, bares, pubs, etc.)
    para aquisição de produtos e serviços para entrega em domicílio, retirada
    e/ou consumo no local. <br />
    <br />

    <b>2. ENCARREGADO </b><br />
    <br />
    A Sociedade indica a pessoa física abaixo qualificada para o cargo de
    “Encarregado”, que ficará então responsável por auxiliar e orientar os
    Usuários e os titulares de dados em todas as questões relativas a este Aviso
    de Privacidade ou ao tratamento de dados pessoais realizado pela Sociedade,
    assim como para atuar como canal de comunicação entre os Usuários, a
    Sociedade e a Autoridade Nacional de Proteção de Dados.
    <div class="flex flex-col mt-4 pl-12">
      <span><b>Nome:</b> Lucas Almeida</span>
      <span><b>E-mail:</b> lucas.almeida&#64;mobo.com.br</span>
      <span><b>Telefone:</b> (51) 35173206</span>
    </div>
    <br />
    <br />

    <b
      >3. TRATAMENTO DE DADOS <br />
      <br />
      Para efetuar o cadastro e acessar a Plataforma, o Usuário precisará
      fornecer determinadas informações para a Sociedade, as quais são
      imprescindíveis para o funcionamento da Plataforma. Assim, serão
      necessariamente coletados e tratados os seguintes dados pessoais dos
      Usuários:
    </b>
    Se o Usuário for um Cliente da Plataforma:
  </div>

  <div>
    <ul class="my-4 pl-12 list-inside list-disc">
      <li>Nome;</li>
      <li>E-mail;</li>
      <li>Celular;</li>
      <li>Data de Nascimento;</li>
      <li>Localização;</li>
      <li>Cupons Consumidos;</li>
      <li>Cupons baixados;</li>
      <li>Endereço; e,</li>
      <li>Login e senha.</li>
    </ul>
    <p class="mb-4">
      Se o Usuário for o Representante legal de um Cliente menor de idade da
      Plataforma:
    </p>
    <ul class="mb-4 pl-12 list-inside list-disc">
      <li>Nome;</li>
      <li>E-mail;</li>
      <li>RG e CPF; e,</li>
      <li>Data de Nascimento.</li>
    </ul>
    <p class="mb-4">Se o Usuário for o Representante legal de um Anunciante:</p>
    <ul class="mb-4 pl-12 list-inside list-disc">
      <li>Nome;</li>
      <li>E-mail;</li>
      <li>Telefone;</li>
      <li>Data de Nascimento:;</li>
      <li>Localização;</li>
      <li>Endereço;</li>
      <li>Empresa em que trabalha; e,</li>
      <li>Login e senha.</li>
    </ul>
  </div>

  <p class="mb-4">
    <b>
      Ao acessar ou usar a Plataforma, você Usuário está ciente - como pessoa
      física e, sempre que aplicável, também como representante de menor de
      idade, de criança, de pessoa jurídica ou de entidade por você representada
      - com o tratamento dos dados listados acima, bem como declara que ao
      inserir dados de terceiros, pessoais ou não, na Plataforma (diretamente ou
      mediante a inserção de documentos contendo tais dados), tal inserção está
      de acordo com os termos da legislação vigente e não viola direitos de
      terceiros, responsabilizando-se por toda e qualquer reclamação ou prejuízo
      decorrente do tratamento de dados pessoais por você inseridos na
      Plataforma (diretamente ou mediante a inserção de documentos contendo tais
      dados).
    </b>
  </p>

  <p>
    <b>4. FINALIDADES E USO DOS DADOS</b><br /><br />
    O presente Aviso de Privacidade lista abaixo as situações em que - e as
    finalidades para as quais - os dados dos Usuários, assim como os dados de
    terceiros de qualquer modo inseridos na Plataforma pelos Usuários, são
    utilizados pela Sociedade:
  </p>
  <p class="pl-12">
    <b> <u>Serviços:</u> </b>
    A Sociedade utilizará dados pessoais para as seguintes finalidades: (a)
    facilitar a identificação do Usuário na Plataforma; (b) fornecer a
    interatividade necessária na Plataforma; (c) operar e aperfeiçoar a
    Plataforma; (d) prestar serviços de atendimento aos Usuários; (e) viabilizar
    a prestação dos serviços contratados pelos Usuários; (f) aproximar o Usuário
    do Anunciante (restaurantes, bares, pubs, etc.) que ofereceu os produtos ou
    serviços adquiridos pelo Usuário, garantindo uma melhor experiência; (g)
    analisar o perfil dos Usuário a fim de disponibilizar os melhores conteúdos
    e ferramentas aos Usuários; assim como pelos menores de idade, crianças,
    entidades ou sociedades que os Usuários representam.
    <br />
    <br />
    <b> <u>Comunicação:</u> </b> A Sociedade utilizará os dados pessoais dos
    Usuários para entrar em contato com o Usuário por e-mail, assim como para
    enviar avisos, mensagens de texto, lembretes e/ou notificações “push”. A
    Sociedade poderá enviar aos Usuários comunicações sobre a disponibilidade da
    Plataforma, sobre as soluções disponibilizadas pela Sociedade, sobre a
    segurança da Plataforma ou sobre outras questões de qualquer modo
    relacionadas à Plataforma ou aos serviços e soluções ofertados através da
    Plataforma ou pela Sociedade, como mensagens sobre como usar tais serviços e
    soluções ou informações sobre atualizações eventualmente disponíveis.

    <br />
    <br />
    <b> <u>Publicidade:</u> </b> A Sociedade poderá utilizar os dados pessoais
    coletados para: (a) enviar e-mails marketing relativos à Plataforma, à
    Sociedade e/ou a empresas do mesmo grupo econômico da Sociedade; (b)
    personalizar campanhas de publicidade da Sociedade e de Anunciantes da
    Plataforma; e (c) exibir e/ou enviar anúncios que sejam compatíveis com o
    perfil do Usuário, sendo que tais anúncios podem ser referentes à Plataforma
    e/ou a terceiros. Caso o Usuário não tenha mais interesse em receber
    anúncios, o Usuário deverá entrar em contato com o Encarregado, informando
    que não deseja mais receber comunicações de caráter publicitário.

    <br /><br />
    <b> <u>Atividades dos Usuários na Plataforma:</u> </b>
    A Sociedade registra os dados de acesso e uso da Plataforma quando os
    Usuários de qualquer forma acessam ou de qualquer forma usam a Plataforma. A
    Plataforma utiliza as informações de acesso, os cookies, as informações do
    dispositivo e os endereços de IP (Internet Protocol) para identificar os
    Usuários ou registrar o uso que eles fazem da - ou a atividade deles na -
    Plataforma.

    <br />
    <br />
    <b> <u>Armazenamento e backup:</u> </b>
    A Sociedade armazena de modo seguro e realiza cópias de segurança das
    informações relativas à Plataforma, as quais podem incluir dados pessoais
    dos Usuários e de terceiros que tenham sido inseridos na Plataforma
    (diretamente ou mediante a inserção de documentos contendo tais dados) ou
    através dela coletados.
  </p>

  <br />
  <br />
  <p>
    <b>5. COOKIES E TECNOLOGIAS SIMILARES</b> <br />
    <br />
    A Plataforma poderá usar cookies ou outras tecnologias para ajudar a
    personalizar a experiência dos Usuários. Cookies são pequenos arquivos de
    texto armazenados na memória do seu computador. Um cookie contém informações
    que poderão ser lidas posteriormente por um servidor localizado no domínio
    que o emitiu. As informações que os cookies coletam incluem, entre outras, a
    data e o horário da visita dos Usuários, histórico de navegação dos Usuários
    etc. <br />
    <br />
    Os cookies trazem diversos benefícios, uma vez que permitem identificar
    Usuários antigos quando estes retornam à Plataforma, possibilitando seu
    direcionamento a conteúdo personalizado e/ou serviços e produtos similares.
    Os cookies também poupam tempo, tornando desnecessário inserir as mesmas
    informações diversas vezes.
    <br />
    <br />
    <b>6. DURAÇÃO DO TRATAMENTO DOS DADOS</b> <br />
    <br />
    Os dados pessoais, incluídos na Plataforma ou através dela coletados, serão
    tratados pela Sociedade enquanto perdurarem as finalidades indicadas neste
    Aviso de Privacidade e/ou houver necessidade de manutenção dos mesmos, como,
    por exemplo, para respeitar os prazos legais de guarda, incluindo aqueles
    descritos na Lei no. 12.965/14 (Marco Civil da Internet) e no Decreto no.
    8.771/16, ou para cumprimento de obrigações legais ou regulatórias
    aplicáveis. <br />
    <br />
    Finda a finalidade ou a necessidade legal, os dados serão excluídos através
    de métodos de descarte seguro, ou utilizados de forma anonimizada para fins
    meramente estatísticos. <br />
    <br />
    Os Usuários e titulares de dados pessoais tratados pela Sociedade poderão
    solicitar informações adicionais sobre os prazos de tratamento de dados
    pessoais adotados pela Sociedade e respectivas formas de descarte, devendo,
    para tanto, contatar o Encarregado.
    <br />
    <br />
    <b>7. RESPONSABILIDADES E DECLARAÇÕES DO USUÁRIO</b>
    <br />
    <br />
    O Usuário declara e reconhece que, ao inserir dados, incluindo dados
    pessoais de terceiros, na Plataforma (diretamente ou mediante a inserção de
    documentos contendo tais dados):
  </p>
  <br />
  <p class="pl-12">
    🗸 previamente, informou os respectivos titulares e tomou todas as medidas
    necessárias para que os titulares tivessem ciência do tratamento de seus
    dados pessoais pela Sociedade; <br />
    <br />
    🗸 no caso da inserção de dados pessoais de menores de idade ou crianças,
    cientificou e obteve, previamente, o consentimento dos responsáveis legais
    no tocante ao tratamento de tais dados pela Sociedade; <br />
    <br />
    🗸 no caso da inserção de dados pessoais sensíveis de terceiros (origem
    racial ou étnica, convicção religiosa, opinião política, filiação a
    sindicato ou a organização de caráter religioso, filosófico ou político,
    dado referente à saúde ou à vida sexual, dado genético ou biométrico, quando
    vinculado a uma pessoa natural etc.), cientificou e obteve, previamente, o
    consentimento dos titulares de tais dados no tocante ao tratamento dos
    referidos dados pela Sociedade; <br />
    <br />
    🗸 as informações inseridas na Plataforma, incluindo eventuais dados
    pessoais, são completas, verídicas e atualizadas, bem como não violam
    quaisquer direitos de terceiros ou normas legais aplicáveis.
    <br />
    <br />
  </p>

  <p class="mb-2">
    O Usuário declara, ainda, que, ao acessar a Plataforma, será diligente, bem
    como usará os documentos e as informações de outros Usuários ou de terceiros
    somente para os propósitos por ele autorizados ou razoavelmente esperados.
    <br />
    <br />
    Caso as declarações acima não estejam totalmente corretas e/ou as obrigações
    ora assumidas não sejam adequadamente cumpridas, o Usuário se responsabiliza
    de forma exclusiva e integral por quaisquer prejuízos causados à Sociedade
    ou a quaisquer terceiros, incluindo terceiros que sejam também Usuários da
    Plataforma. <br />
    <br />
    O Usuário compromete-se a ser diligente na guarda e a não compartilhar seus
    dados de acesso à Plataforma (i.e. login e senha) com quaisquer terceiros,
    assim como se responsabiliza pelas atividades que executa na Plataforma ou
    pelas informações, incluindo dados pessoais, que insere na Plataforma
    (diretamente ou mediante a inserção de documentos contendo tais dados).
    <br />
    <br />
    As informações de acesso à Plataforma devem ser tratadas como confidenciais
    e não devem ser compartilhadas. Ao confirmar o cadastro na Plataforma, o
    Usuário se declara plenamente ciente de que será o único responsável pelas
    operações realizadas por meio de seu login, cujo acesso somente será
    permitido após o fornecimento de senha de uso pessoal e intransferível.
    <br />
    <br />
    Na hipótese da Sociedade ser demandada, a qualquer tempo, em razão de fatos
    ou atos cuja responsabilidade seja atribuída ao Usuário nos termos deste
    Aviso de Privacidade, o Usuário, assim como o menor, a criança, a entidade
    ou a sociedade que ele representa, serão responsáveis de forma solidária e
    deverão: (a) intervir voluntariamente no feito, pleiteando a imediata
    exclusão da Sociedade da lide, (b) assumir a responsabilidade integral e
    exclusiva pelo pagamento e/ou pelas providências reclamadas, e (c) ressarcir
    integralmente a Sociedade pelos custos e despesas porventura incorridos em
    consequência da demanda. Caso não se opere a referida exclusão, o Usuário, o
    menor, a criança e/ou a entidade ou sociedade que o Usuário representa,
    responderá pelo pagamento e pelo cumprimento integral da decisão ou, se
    aplicável, deverá ressarcir imediatamente a Sociedade.
  </p>
  <p>
    <br />
    <br />
    <b>8. COMPARTILHAMENTO DE DADOS</b> <br />
    <br />
    O presente Aviso de Privacidade indica abaixo as situações em que os dados
    pessoais dos Usuários, assim como os dados pessoais de terceiros de qualquer
    modo inseridos na Plataforma pelos Usuários, serão compartilhados pela
    Sociedade: <br />
    <br />
  </p>
  <p class="pl-12 mb-4">
    <br />
    <b><u>Empresas do grupo :</u></b>
    A Sociedade poderá compartilhar informações, incluindo dados pessoais dos
    Usuários e de terceiros, com afiliadas e empresas do mesmo grupo sempre que
    tal compartilhamento for importante para a operação da Plataforma, para o
    cumprimento de obrigações legais e/ou forem do interesse do Usuário. <br />
    <br />
    <b><u>Operações societárias :</u></b>
    Em decorrência de eventuais operações de reestruturação societária, fusões,
    aquisições, incorporações e similares, a Sociedade poderá compartilhar ou
    mesmo transferir informações, incluindo dados pessoais dos Usuários e de
    terceiros, para as pessoas físicas ou jurídicas de qualquer modo envolvidas
    na operação. <br />
    <br />
    <b><u>Parceiros e prestadores de serviços:</u></b>
    A Sociedade poderá compartilhar informações, incluindo dados pessoais dos
    Usuários e de terceiros, com empresas, organizações ou indivíduos que
    prestam serviços em nome da Sociedade para, por exemplo, processar
    pagamentos, implementar medidas de segurança etc. Essas empresas receberão
    permissão para obter apenas as informações necessárias para prestar o
    serviço adequadamente e poderão ser obrigadas a manter a confidencialidade
    das informações. <br />
    <br />
    <b><u>Prevenção de fraudes e segurança :</u></b>
    <strong
      >A Sociedade poderá divulgar ou compartilhar informações, incluindo dados
      pessoais dos Usuários e de terceiros, se acreditar, de boa-fé, que o
      acesso, o uso, a conservação ou a divulgação das informações seja
      razoavelmente necessário para (a) detectar ou impedir fraudes, bem como
      resolver questões técnicas ou de segurança, e; (b) garantir a segurança da
      Plataforma, da Sociedade, dos Usuários e de terceiros. Neste caso, os
      dados e as informações poderão ser compartilhados com terceiros
      responsáveis pela investigação, incluindo órgãos do judiciário,
      autoridades e empresas de tecnologia da informação ou segurança da
      informação.</strong
    >
    <br />
    <br />
    <b><u>Demandas judiciais e investigações :</u></b>
    A Sociedade poderá divulgar ou compartilhar informações, incluindo dados
    pessoais dos Usuários e de terceiros, com autoridades e/ou órgãos públicos,
    agências regulatórias, autoridades legais (e.g. delegacias regionais),
    autarquias, órgãos de defesa do consumidor, órgãos do governo e do
    judiciário e/ou advogados nos seguintes casos: (a) para o cumprir decisão
    judicial ou solicitação governamental; (b) para resguardar direitos e
    prevenir responsabilidades da Sociedade; (c) para investigar, impedir ou
    tomar medidas relacionadas a atividades ilegais, suspeitas ou reais, ou para
    cooperar com órgãos públicos, e; (d) investigar possíveis violações de
    direitos da Sociedade e/ou de terceiros. <br />
    <br />
    <b><u>Cumprimento de obrigações legais ou regulatórias: :</u></b>
    A Sociedade poderá divulgar ou compartilhar informações, incluindo dados
    pessoais de Usuários e de terceiros, para cumprir obrigações legais,
    regulatórias ou qualquer outra determinação perante órgãos do governo e do
    judiciário, incluindo, mas não se limitando a, Ministérios e/ou Secretarias
    do Governo, autarquias federais, agências regulatórias e/ou autoridades
    legais (e.g. Secretaria da Receita Federal), órgãos de defesa do consumidor,
    órgãos judiciais e outros.
    <br />
    <br />
    <b><u>Anunciantes: :</u></b>
    Os dados dos Clientes da Plataforma poderão ser compartilhados com os
    Anunciantes, devidamente cadastrados na Plataforma, os quais também
    obrigam-se a cumprir a legislação de proteção de dados, para que tais
    empresas possam auxiliar os Clientes a usufruir de seus produtos e serviços,
    bem como realizar atividades comerciais que envolvam o oferecimento de
    promoções, personalização de campanhas de publicidade e aproximação com o
    Usuário, sempre em benefício deste, garantindo uma melhor experiência. Caso
    o Usuário não mais tenha interesse no compartilhamento dos seus dados com
    Anunciantes, deverá entrar em contato com o Encarregado, pelo e-mail acima
    indicado.
  </p>
  <br />
  <br />
  <p>
    <b>9. AGENTES DE TRATAMENTO </b> <br />
    <br />
    Toda e qualquer sociedade, entidade pública ou privada, autoridade, órgão,
    agência e/ou pessoa que tiver acesso aos dados pessoais dos Usuários e/ou de
    terceiros, de acordo com as situações previstas no capítulo
    “Compartilhamento de Dados”, passará a assumir a posição de agente de
    tratamento e estará obrigada, nos termos da legislação aplicável e/ou dos
    contratos firmados com a Sociedade, a adotar as melhores práticas de
    segurança e governança no tocante à proteção e tratamento dos dados pessoais
    que tiverem acesso.
  </p>
  <br />
  <br />
  <p>
    <b>10. SEGURANÇA DA INFORMAÇÃO </b> <br />
    <br />
    A segurança das informações é muito importante para a Sociedade. A Sociedade
    segue os padrões de segurança do setor para ajudar a proteger as informações
    inseridas na Plataforma. Entretanto, não existe nenhum método de
    armazenamento eletrônico que seja totalmente seguro. DESSA FORMA, EMBORA NOS
    ESFORCEMOS PARA PROTEGER AS INFORMAÇÕES TRATADAS NA PLATAFORMA, AS QUAIS
    INCLUEM DADOS PESSOAIS, NÃO PODEMOS GARANTIR SEGURANÇA ABSOLUTA.
    <br />
    <br />
    A Sociedade armazenará os dados pessoais dos Usuários e de terceiros em
    ambiente seguro, comprometendo-se a adotar medidas razoáveis de precaução
    para evitar perdas, abusos, alterações ou acessos não autorizados
    relacionados a estes dados
  </p>
  <br />
  <br />
  <p>
    <b>11. LINKS </b> <br />
    <br />
    <strong
      >O Usuário concorda em não responsabilizar a Sociedade por perdas, danos
      ou outros problemas de qualquer espécie que possam surgir da utilização de
      <i>websites</i> que contenham <i>links</i> para a Plataforma, ou cujos
      <i>links</i> estejam disponíveis na Plataforma, bem como está ciente de
      que qualquer negociação com tais <i>websites</i> não envolve, vincula e/ou
      obriga a Sociedade.</strong
    >
  </p>
  <br />
  <br />
  <p>
    <b>12. CONTROLE DE SEUS DADOS </b> <br />
    <br />
    A Sociedade disponibilizará meios para que Usuários possam acessar,
    corrigir, excluir ou modificar os dados que foram por eles inseridos na
    Plataforma, bem como para que terceiros, titulares de dados pessoais
    inseridos na Plataforma, possam solicitar a correção, a exclusão ou a
    modificação dos respectivos dados pessoais. As opções dos Usuários e dos
    titulares de dados pessoais seguem abaixo listadas:
  </p>
  <br />
  <p class="pl-12 mb-4">
    <b><u>Confirmação da existência de tratamento:</u></b> O Usuário e o titular
    de dados pessoais podem solicitar a confirmação no tocante à existência de
    tratamento de seus dados pessoais. <br />
    <br />
    <b><u>Direito de acessar os seus dados:</u></b>
    O Usuário e o titular de dados pessoais podem solicitar uma cópia dos dados
    tratados, a qual será disponibilizada em um formato legível e eletrônico.
    <br />
    <br />
    <b><u>Alteração ou correção de dados:</u></b> O Usuário e o titular de dados
    pessoais podem solicitar atualizações, alterações ou correções de seus dados
    em determinados casos, especialmente se os referidos dados estiverem
    incorretos ou desatualizados. <br />
    <br />
    <b><u>Exclusão, bloqueio e/ou anonimização de dados:</u></b>
    O Usuário e o titular de dados pessoais podem solicitar a exclusão de seus
    dados da Plataforma e dos repositórios da Sociedade sem a necessidade de
    apresentar qualquer justificativa, assim como poderão solicitar a exclusão,
    o bloqueio e/ou a anonimização dos referidos dados pessoais.<br />
    <br />
    <b><u>Portabilidade:</u></b>
    O Usuário e o titular de dados pessoais podem solicitar a portabilidade dos
    seus dados a outro fornecedor de serviços ou produtos. <br />
    <br />
    <b><u> Informações sobre o compartilhamento dos dados:</u></b>
    O Usuário e o titular de dados pessoais poderão solicitar informações acerca
    das entidades públicas e/ou privadas com as quais a Sociedade compartilhou
    seus dados pessoais.
    <br />
    <br />
    <b><u> Informações sobre o consentimento:</u></b>
    O Usuário e o titular de dados pessoais poderão solicitar informações sobre
    a possibilidade de não fornecer consentimento em situações específicas e
    sobre as consequências do não fornecimento do consentimento.
    <br />
    <br />
    <b><u> Revogação de consentimento:</u></b> Para os casos em que o Usuário
    outorgou consentimento à Sociedade para o tratamento de seus dados pessoais,
    o Usuário poderá, a qualquer tempo, revogar este consentimento.
    <br />
    <br />
    <b><u> Canais para exercer os seus direitos:</u></b> Para exercer os
    direitos acima elencados, o Usuário ou o titular de dados pessoais deverá
    dirigir sua solicitação ao Encarregado. Na referida solicitação, deverá
    constar: (a) a qualificação do Usuário (nome completo, login e senha) ou do
    titular de dados pessoais; (b) a especificação da medida que o Usuário ou o
    titular de dados pessoais pretende em relação aos seus dados pessoais, e;
    (c) se for o caso, a especificação dos dados que são objeto da solicitação.
    Dentro do prazo de 15 dias, se a lei não estabelecer prazo distinto, o
    Encarregado responderá à solicitação do Usuário ou do titular de dados
    pessoais: (a) comunicando o atendimento da solicitação; (b) apresentando
    justificativa, caso não seja possível cumprir à solicitação, ou; (c)
    estimando novo prazo para atendimento da solicitação e a justificativa
    relativa à prorrogação do prazo.
  </p>
  <p>
    Há situações em que a Sociedade precisará manter ou não poderá alterar os
    dados pessoais e, por tal razão, não poderá atender às solicitações
    realizadas, ainda que observadas as regras acima (e.g. quando a manutenção
    dos dados pessoais se mostrar necessária para o cumprimento de obrigações
    legais ou para atender ordem judicial). O Usuário deverá informar
    imediatamente a Sociedade, através do Encarregado, quando for necessária a
    cooperação da Sociedade para alterar, atualizar, complementar, corrigir ou
    excluir dados pessoais de um terceiro que foram incluídos pelo Usuário na
    Plataforma. O Usuário deverá fornecer todas as informações relevantes para
    que a Sociedade possa tomar as providências necessárias dentro de um prazo
    razoável.
  </p>
  <br />
  <br />
  <p>
    <b>13. REIVINDICAÇÃO DE DIREITOS</b> <br />
    <br />
    Se um Usuário ou um titular de dados pessoais acreditar que a Plataforma
    viola seus direitos e/ou sua privacidade, incluindo no tocante ao tratamento
    de dados pessoais, poderá ele comunicar a Sociedade através do Encarregado.
    <br />
    <br />
    Nada do que está escrito neste Aviso de Privacidade tem como intenção
    excluir ou limitar qualquer condição, garantia, direito ou responsabilidade
    que não possa ser legalmente excluída ou limitada. Algumas jurisdições não
    permitem a exclusão de certas garantias ou condições ou a limitação ou
    exclusão de responsabilidade civil. Consequentemente, apenas as limitações
    que forem permitidas por lei na sua jurisdição se aplicarão a você. NOS
    CASOS EM QUE EXCLUSÃO DE RESPONSABILIDADE NÃO SE MOSTRAR POSSÍVEL, MAS A
    LIMITAÇÃO DE RESPONSABILIDADE FOR LEGALMENTE APLICÁVEL, A RESPONSABILIDADE
    TOTAL DA SOCIEDADE NO TOCANTE AO TRATAMENTO DE DADOS PESSOAIS OU INCIDENTES
    DE QUALQUER MODO RELACIONADOS A DADOS PESSOAIS ESTARÁ LIMITADA A R$ 2.000,00
    (DOIS MIL REAIS).
  </p>
  <br />
  <br />
  <p>
    <b>14. TRANSFERÊNCIA DE DADOS ENTRE FRONTEIRAS</b> <br />
    <br />
    A SOCIEDADE PROCESSA DADOS, INCLUINDO DADOS PESSOAIS, DENTRO DO BRASIL E EM
    OUTROS PAÍSES. É POSSÍVEL QUE ALGUNS DOS PAÍSES EM QUESTÃO TENHAM LEIS MENOS
    PROTETIVAS NO TOCANTE À PRIVACIDADE E/OU DADOS PESSOAIS, OU SEQUER POSSUAM
    REGULAMENTAÇÃO ESPECÍFICA SOBRE O ASSUNTO. VOCÊ ESTÁ CIENTE E CONCORDA QUE
    OS SEUS DADOS PESSOAIS E OS DADOS PESSOAIS DE TERCEIROS POR VOCÊ INSERIDOS
    NA PLATAFORMA PODERÃO TRANSITAR POR - OU RECEBER TRATAMENTO EM - OUTROS
    PAÍSES, E, EM ESPECIAL, NOS ESTADOS UNIDOS DA AMÉRICA..
    <span class="block m-6">Alterações, validade e Vigência das Cláusulas</span>
    Qualquer renúncia ou alteração dos dispositivos deste Aviso de Privacidade
    só terá efeito caso apresentada por escrito e assinada pelos representantes
    legais da Sociedade. Se alguma disposição do Aviso de Privacidade for
    anulada ou considerada inaplicável, as demais disposições, sempre que
    possível, permanecerão válidas e vigentes.
    <br />
    <br />
    A Sociedade reserva-se o direito de alterar o Aviso de Privacidade, bem como
    qualquer política ou documento da Plataforma, a qualquer momento e ao seu
    exclusivo critério. <br />
    <br />
    As alterações entrarão em vigor no momento da respectiva publicação na
    Plataforma. O uso da Plataforma depois da publicação constituirá ciência das
    eventuais alterações do Aviso de Privacidade. Dessa forma, aconselhamos os
    Usuários a relerem o Aviso de Privacidade com frequência ou sempre que
    acessarem a Plataforma. <br />
    <br />
    Caso haja divergência entre o conteúdo deste Aviso de Privacidade e aquele
    constante de outro(s) documento(s) assinado(s) entre o Usuário e a
    Sociedade, prevalecerá, sempre, o conteúdo do(s) outro(s) documento(s)
    assinado(s) pelo Usuário.
  </p>
  <br />
  <br />
  <p>
    <b>15. LEGISLAÇÃO, LITÍGIOS E CONTROVÉRSIAS</b> <br />
    <br />
    Qualquer litígio relacionado ao presente Aviso de Privacidade deverá ser
    submetido ao Foro da Comarca de Porto Alegre, Estado do Rio Grande do Sul,
    Brasil, que prevalecerá sobre qualquer outro, por mais privilegiado que seja
    ou venha a se tornar, e será julgado exclusivamente conforme as leis da
    República Federativa do Brasil.
  </p>
  <br />
  <br />
  <p>
    <b>16. PERGUNTAS E ESCLARECIMENTOS</b>
    <br />
    <br />
    Perguntas, solicitações, reclamações e comentários sobre a Plataforma ou
    sobre o Aviso de Privacidade poderão ser dirigidos ao Encarregado.
  </p>
</div>
